// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatEmptyChatNotice-moduleroot__iG6vR";
export { _1 as "root" }
